export const resolveI18nObject = (
  stringifiedObject: string,
  selectedLanguage: string = 'en',
) => {
  let parsedObj = JSON.parse(stringifiedObject);
  return parsedObj[selectedLanguage];
};
